// extracted by mini-css-extract-plugin
module.exports = {"card":"Login_card__61ZXB","form":"Login_form__1tdal","title":"Login_title__1lY0k"};